export function splitBodyParagraphs(body: string): string[] {
  const t = body.trim();
  if (!t) {
    return [];
  }
  return t
    .split(/\r?\n\s*\r?\n+/)
    .map((p) => p.trim())
    .filter(Boolean);
}
